import "./footer.css";
import { FiFacebook, FiInstagram, FiLinkedin, FiMail } from "react-icons/fi";

export default function Footer() {
  return (
    <footer className="footer-wrapper">
      {/* ================= FOOTER CARD ================= */}
      <div className="footer-card">
        {/* 🔥 LIGHT RAYS INSIDE FOOTER BOX */}

        {/* ================= CONTENT ================= */}
        <div className="footer-content">
          {/* BRAND */}
          <div className="footer-col brand">
            <img src="/flytutor_logo.jpeg" alt="Flytutor Logo" />
            <p className="brand-text">
              DGCA-approved drone pilot training & advanced UAV solutions for
              professionals and enterprises.
            </p>
            <p>Manikampalayam, Koothampoondi, Tamil Nadu 637202</p>
            <p>info@flytutor.in</p>
            <p>+91 90039 92693</p>
          </div>

          {/* COMPANY */}
          <div className="footer-col">
            <h4>Company</h4>
            <a href="/">Home</a>
            <a href="/course">Courses</a>
            <a href="/about">About Us</a>
            <a href="/contact">Contact</a>
          </div>

          {/* LEGAL */}
          <div className="footer-col">
            <h4>Legal</h4>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-and-conditions">Terms & Conditions</a>
          </div>

          {/* CTA + SOCIAL */}
          <div className="footer-col footer-action">
            <button className="footer-btn">ENQUIRE NOW</button>

            <div className="footer-socials">
              <a href="mailto:info@flytutor.in" aria-label="Email">
                <FiMail />
              </a>
              <a
                href="https://www.facebook.com/flytutortechnologies"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FiFacebook />
              </a>
              <a
                href="https://www.instagram.com/flytutor_rpto"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FiInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/flytutor-technologies"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FiLinkedin />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ================= WATERMARK ================= */}
      <div className="footer-watermark">
        <svg
          viewBox="0 0 1200 200"
          preserveAspectRatio="xMidYMid meet"
          className="watermark-svg"
        >
          <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle">
            FLYTUTOR
          </text>
        </svg>
      </div>

      {/* ================= COPYRIGHT ================= */}
      <div className="footer-bottom">
        © 2025 Flytutor Technologies Pvt Ltd. All Rights Reserved.
      </div>
    </footer>
  );
}